import PropTypes from 'prop-types'

export const productListPagePropTypes = {
  title: PropTypes.string,
}

export const productListPageDefaultProps = {
  title: 'Products',
}
